(function() {
    'use strict';

    angular
        .module('app.paperworks')
        .controller('BehaviorInterventionSstController', BehaviorInterventionSstController);

    function BehaviorInterventionSstController($scope, $state, studentsService, $rootScope, $stateParams, ClassesService, toastr, paperworksService, SweetAlert, $location, $anchorScroll, helperService, $filter, $timeout) {
        var vm = this;
        /* Assign Property */
        vm.showSearchBox = true;
        vm.showDetails = false;
        vm.minitorId = [];
        vm.test = false;
        vm.periods = [];
        vm.students = [];
        vm.studentname = "Student's Name";
        vm.Sid = '';
        vm.studentperiod = "Student's Name";
        vm.studentgender = "Student's Gender";
        vm.studentgrade = "Student's Grade";
        //vm.reasonskill = '';
        vm.preview = ($stateParams.viewtype == 'view') ? true : false;
        vm.interventions = [];
        vm.other_concern = [];
        vm.area_concern = [];
        vm.behaviour_intervention = [];
        vm.other_intervention = [];
        vm.userActivity = [];
        vm.strength = [];
        vm.addtional_behavior = [];
        vm.userSelectedPeriod = '';
        paperworksService.getOptions('/api/paperwork/options?rti_type=BIP-SST').then(function(data) {
            vm.interventions = data.interventions;
            vm.area_of_concern = data.concerns;
            vm.strength = data.strength;
        });

        vm.create_session_notification = 0;
        vm.create_session_notification_2 = 0;
        vm.is_intervention = 0;
        vm.FirstName = '';
        vm.LastName = '';

        vm.paperworkfromClass = $stateParams.paperworkfromClass;
        paperworksService.getOptions('/api/paperwork/additionalbehavior').then(function(data) {
            vm.addtional_behavior = data.addtional_behavior;
        });
        vm.hideforstatus = '';



        vm.labels = [];
        vm.series = ['Series A'];

        vm.datass = [];

        vm.datasetOverride = [{
            fill: true,
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
                "#FF4242",
                "#2291ff"

            ]
        }];

        vm.Bipsst_form = {
            id: 0,
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            other_reason: '',
            date_plan: new Date(),
            category: 2,
            type: 2,
            teacher_initiating: $rootScope.user.first_name + ' ' + $rootScope.user.last_name,
            teacher_collaborator_1: '',
            teacher_collaborator_2: '',
            teacher_collaborator_3: '',
            saved: false
        };

        vm.bipsst_screen = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            screen_by: '',
            screen_date: new Date(),
            screen_measurement_tool: 'behavior-emotional-screening-system',
            screen_other_measurement: '',
            screen_fall_result: '',
            screen_midyr_result: '',
            screen_spring_result: '',
            saved: false
        };
        vm.behaveinformation = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            behavior_information: '',
            saved: false
        };

        vm.attendanceinformation = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            attendance_information: '',
            saved: false
        };

        vm.additonalBehaviors = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            subject: '',
            addbehaviors: [],
            rate: {},
            saved: false


        };

        vm.bip_strength = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            strengths: [],
            other: [],
            saved: false
        };


        vm.bipsst_problem = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            target_behavior_problem: '',
            when_problem: '',
            why_problem: '',
            replacement_behavior: '',
            convey_expectation: '',
            demonstrate_des_behave: '',
            additional_comments: '',
            saved: false

        };

        vm.bipsst_concernform = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            concerns: [],
            area: vm.area_concern,
            other: vm.other_concern,
            saved: false,
        };

        vm.bipsst_intervention = {
            student_id: 0,
            rti_type: 'BIP-SST',
            reason: 'Behavior',
            type: 'Behavior',
            interventions: [],
            behaviour: vm.behaviour_intervention,
            other: vm.other_intervention,
            saved: false
        };


        vm.paperwork_log = [];
        vm.communication_log =[];
        vm.behavior_reports = [];
        vm.attendance_reports = {};
        vm.bipsst_type = [];
        vm.bipsst_monitoring = [];
        vm.bipsst_monitor_log = [];
        vm.bipsst_monitor_result = [];
        vm.checkWindow = checkWindow;
        var timer = '';
        var childWindow;

        /* Assign Methods */

        vm.getstudents = getstudents;
        vm.afterselected = afterselected;
        vm.Bipsst_submit = Bipsst_submit;
        vm.save_intervention = save_intervention;
        vm.save_concern = save_concern;
        vm.toggleSelection = toggleSelection;
        vm.getStudentdata = getStudentdata;
        vm.create_session = create_session;
        vm.update_session = update_session;
        vm.delete_session = delete_session;
        vm.intervention_val = intervention_val;
        vm.saveResult = saveResult;
        vm.saveMonitorStatus = saveMonitorStatus;
        vm.Reset = Reset;
        vm.sendtoAdmin = sendtoAdmin;
        vm.selectStudentByPeriod = selectStudentByPeriod;
        vm.initialize = initialize;
        vm.save_strength = save_strength;
        vm.save_addtionalBehavior = save_addtionalBehavior;
        vm.defaultOptions = defaultOptions;
        vm.addbipSST = addbipSST;
        vm.printpreview = printpreview;
        vm.getRelation = getRelation;


        function addbipSST(myForm, $setPristine) {
            myForm.$setPristine();
        }

        /* onload methods */
        vm.email_notification_message2 = '';
        $rootScope.$on('activity_message', function(event, data) {
            vm.userActivity.push(data);

        });




        getstudents();
        userPeriods();
        defaultOptions();
        $scope.$watch('BehaviorInterventionSstCtrl.userSelectedPeriod', selectStudentByPeriod, false);


        function defaultOptions() {
            if ($state.params.type == 'view') {
                vm.preview = true;
            }
            if ($stateParams.studentId !== null && $stateParams.studentId > 0) {
                vm.showSearchBox = false;
                searchstudent($stateParams.studentId);
            }
        }

        function getstudents() {
            studentsService
                .getallstudentbyUser('/api/students/getstudentbyuser').then(function(students) {
                    vm.students = students;
                });
        }

        function selectStudentByPeriod() {

            if (vm.userSelectedPeriod === '') {
                studentsService
                    .getallstudentbyUser('/api/students/getstudentbyuser').then(function(students) {
                        vm.students = students;
                    });
            } else {

                var data = {
                    period: vm.userSelectedPeriod
                };
                studentsService.getStudentsByuserPeriod('/api/students/getstudentByuserPeriod', data).then(function(response) {
                    vm.students = response;
                });
            }
        }


        function userPeriods() {

            ClassesService.getUserCreatedPeriod('/api/classes/usercreatedperiod').then(function(response) {
                vm.periods = response;
            });

        }

        function afterselected(selected) {
            if (selected) {

                initialize();
                vm.selectedstudent = selected.originalObject;
                //$rootScope.selectedStudentDet = selected.originalObject;
                searchstudent(selected.originalObject.id);
                selected.originalObject = null;
                vm.FirstName = vm.selectedstudent.first_name;
                vm.LastName = vm.selectedstudent.last_name;
            }
        }

        function searchstudent(studentid) {
            studentsService.getStudentwithClasses('api/student/alldetail?id=' + studentid).then(function(response) {
                if ($stateParams.studentId !== null && $stateParams.studentId > 0) {
                    vm.selectedstudent = response;
                }

                vm.studentname = response.fullname;
                vm.Sid = response.studentid;
                if (response.studentclass[0]) {
                    vm.studentperiod = response.studentclass[0].period + '' + response.studentclass[0].period_letter;
                    vm.studentgrade = response.studentclass[0].grade;
                } else {
                    vm.studentperiod = 'N/A';
                    vm.studentgrade = 'N/A';
                }
                vm.studentgender = response.gender_type;
                vm.bipsst_concernform.student_id = response.id;
                vm.Bipsst_form.student_id = response.id;
                vm.bipsst_screen.student_id = response.id;
                vm.bip_strength.student_id = response.id;
                vm.bipsst_problem.student_id = response.id;
                vm.bipsst_intervention.student_id = response.id;
                vm.behavior_reports = response.behavior;
                vm.bip_strength.student_id = response.id;
                vm.additonalBehaviors.student_id = response.id;
                vm.attendanceinformation.student_id = response.id;
                vm.attendance_reports = {
                    total_absent: response.total_absents,
                    total_skiped: response.total_skipes,
                    total_tardy: response.total_tardies
                };
                paperworksService.getipData('/api/paperwork/aip?rti_type=BIP-SST&type=Behavior&student_id=' + response.id).then(function(data) {
                    getStudentdata(data);
                });
            });
        }

        function getStudentdata(data) {
            if (data.ip) {
                vm.Bipsst_form.id = data.ip.id;
                vm.Bipsst_form.reason = data.ip.reason;
                vm.Bipsst_form.date_plan = data.ip.date_plan;
                vm.Bipsst_form.category = data.ip.category;
                vm.Bipsst_form.type = data.ip.type;
                vm.Bipsst_form.teacher_initiating = data.ip.teacher_initiating;
                vm.Bipsst_form.teacher_collaborator_1 = data.ip.teacher_collaborator_1;
                vm.Bipsst_form.teacher_collaborator_2 = data.ip.teacher_collaborator_2;
                vm.Bipsst_form.teacher_collaborator_3 = data.ip.teacher_collaborator_3;
                if (vm.Bipsst_form.reason !== null || vm.Bipsst_form.date_plan !== null || vm.Bipsst_form.teacher_initiating !== null)
                    vm.Bipsst_form.saved = true;

                vm.bipsst_screen.screen_by = data.ip.screen_by;
                vm.bipsst_screen.screen_date = data.ip.screen_date;
                if (data.ip.screen_measurement_tool !== null)

                    vm.bipsst_screen.screen_measurement_tool = data.ip.screen_measurement_tool;
                vm.bipsst_screen.screen_fall_result = data.ip.screen_fall_result;
                vm.bipsst_screen.screen_midyr_result = data.ip.screen_midyr_result;
                vm.bipsst_screen.screen_spring_result = data.ip.screen_spring_result;

                if (vm.bipsst_screen.screen_by !== null || vm.bipsst_screen.screen_date !== null || vm.bipsst_screen.screen_measurement_tool !== null || vm.bipsst_screen.screen_fall_result !== null || vm.bipsst_screen.screen_midyr_result !== null || vm.bipsst_screen.screen_spring_result !== null)
                    vm.bipsst_screen.saved = true;

                vm.bipsst_problem.target_behavior_problem = data.ip.target_behavior_problem;
                vm.bipsst_problem.why_problem = data.ip.why_problem;
                vm.bipsst_problem.when_problem = data.ip.when_problem;
                vm.bipsst_problem.replacement_behavior = data.ip.replacement_behavior;
                vm.bipsst_problem.convey_expectation = data.ip.convey_expectation;
                vm.bipsst_problem.demonstrate_des_behave = data.ip.demonstrate_des_behave;

                vm.bipsst_problem.additional_comments = data.ip.additional_comments;

                if (vm.bipsst_problem.target_behavior_problem !== null || vm.bipsst_problem.why_problem !== null || vm.bipsst_problem.when_problem !== null || vm.bipsst_problem.replacement_behavior !== null || vm.bipsst_problem.convey_expectation !== null || vm.bipsst_problem.demonstrate_des_behave !== null || vm.bipsst_problem.additional_comments !== null)
                    vm.bipsst_problem.saved = true;

                vm.behaveinformation.behavior_information = data.ip.behavior_information;
                if (vm.behaveinformation.behavior_information == 1)
                    vm.behaveinformation.saved = true;
                vm.attendanceinformation.attendance_information = data.ip.attendance_information;
                if (vm.attendanceinformation.attendance_information == 1)
                    vm.attendanceinformation.saved = true;

                if (vm.Bipsst_form.saved === true && vm.bipsst_problem.saved === true && vm.attendanceinformation.saved === true) {
                    vm.create_session_notification = 3;
                }

            }

            //vm.aip_concern = data.aip_concern;
            if (data.ip_concern) {
                if (data.ip_concern.length)
                    vm.bipsst_concernform.saved = true;
                for (var i = 0; i < data.ip_concern.length; i++) {
                    vm.bipsst_concernform.concerns.push(data.ip_concern[i].subject + '~' + data.ip_concern[i].option);
                    if (data.ip_concern[i].option == 'Other')
                        vm.other_concern[data.ip_concern[i].subject] = data.ip_concern[i].other_option;
                    else if (data.ip_concern[i].option.indexOf('#') !== -1)
                        vm.area_concern[data.ip_concern[i].subject] = data.ip_concern[i].other_option;
                }
                $scope.getCheckedTrue = function(val) {

                    if (vm.bipsst_concernform.concerns.indexOf(val) !== -1) {
                        return true;
                    }

                };

                if (vm.bipsst_concernform.saved === true) {
                    vm.create_session_notification += 1;

                }


            }

            if (data.ip_strength) {
                if (data.ip_strength.length)
                    vm.bip_strength.saved = true;
                for (var k = 0; k < data.ip_strength.length; k++) {
                    vm.bip_strength.strengths.push(data.ip_strength[k].strength_val + '~' + data.ip_strength[k].strength_text);

                    if (data.ip_strength[k].strength_text.indexOf('#') !== -1)
                        vm.bip_strength.other[data.ip_strength[k].strength_val] = data.ip_strength[k].other_strength;
                }
                if (vm.bip_strength.saved === true) {
                    vm.create_session_notification += 1;
                }
            }

            if (data.ip_additionalbehavior) {

                if (data.ip_additionalbehavior.length) {
                    vm.additonalBehaviors.saved = true;
                    for (var x = 0; x < data.ip_additionalbehavior.length; x++) {
                        vm.additonalBehaviors.addbehaviors.push(data.ip_additionalbehavior[x].subject + '~' + data.ip_additionalbehavior[x].option);
                        vm.additonalBehaviors.rate[data.ip_additionalbehavior[x].subject + '' + data.ip_additionalbehavior[x].option] = data.ip_additionalbehavior[x].rate;
                    }
                }


                if (vm.additonalBehaviors.saved === true) {
                    vm.create_session_notification += 1;
                }
            }

            if (data.ip_intervention) {
                if (data.ip_intervention.length)
                    vm.bipsst_intervention.saved = true;
                for (var j = 0; j < data.ip_intervention.length; j++) {
                    vm.bipsst_intervention.interventions.push(data.ip_intervention[j].subject + '~' + data.ip_intervention[j].option);
                    if (data.ip_intervention[j].option == 'Other')
                        vm.other_intervention[data.ip_intervention[j].subject] = data.ip_intervention[j].other_option;
                    else if (data.ip_intervention[j].option.indexOf('#') !== -1)
                        vm.behaviour_intervention[data.ip_intervention[j].subject] = data.ip_intervention[j].other_option;
                }
                $scope.getCheckedIntervention = function(val) {
                    //console.log((val));
                    if (vm.bipsst_intervention.interventions.indexOf(val) !== -1) {
                        return true;
                    }
                };

                vm.create_session_notification += 1;
                vm.is_intervention = 1;
            }

            if (data.ip_monitoring) {
                vm.bipsst_monitoring = data.ip_monitoring;

                angular.forEach(data.ip_monitoring, function(value) {

                    vm.minitorId.push(value.id);

                });

            }
            vm.paperwork_log = data.paperwork_log;
            vm.communication_log = data.communication_log;
            
            if (data.ip_monitoring) {
                vm.bipsst_monitor_log = data.ip_monitor_log;
            }
            if (data.ip_monitoring) {
                vm.bipsst_monitor_result = data.ip_monitor_result;

                angular.forEach(vm.minitorId, function(Id) {

                    vm.labels[Id] = [];
                    vm.datass[Id] = [];
                    angular.forEach(data.ip_monitor_result[Id], function(value) {


                        vm.labels[Id].push(value.intervention_name);
                        vm.datass[Id].push(value.rate);

                    });

                });


            }

            vm.bipsst_type = data.ip_types;

        }

        function printpreview() {
        	timer = setInterval(checkWindow, 500);
            var winName = 'MyWindow';
            var winURL = '/api/paperwork/preview';
            var windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';
            var params = {
                'paperwork_type': 'RTI',
                'formName': 'BIP-SST',
                'form_id': vm.Bipsst_form.id,
                'student_id': vm.Bipsst_form.student_id,
                'reason': vm.Bipsst_form.reason,
                'other_reason': vm.Bipsst_form.other_reason,
                'date_plan': vm.Bipsst_form.date_plan,
                'category': vm.Bipsst_form.category,
                'type': vm.Bipsst_form.type,
                'teacher_initiating': vm.Bipsst_form.teacher_initiating,
                'teacher_collaborator_1': vm.Bipsst_form.teacher_collaborator_1,
                'teacher_collaborator_2': vm.Bipsst_form.teacher_collaborator_2,
                'teacher_collaborator_3': vm.Bipsst_form.teacher_collaborator_3,
                'screen_by': vm.bipsst_screen.screen_by,
                'screen_date': vm.bipsst_screen.screen_date,
                'screen_measurement_tool': vm.bipsst_screen.screen_measurement_tool,
                'screen_other_measurement': vm.bipsst_screen.screen_other_measurement,
                'screen_fall_result': vm.bipsst_screen.screen_fall_result,
                'screen_midyr_result': vm.bipsst_screen.screen_midyr_result,
                'screen_spring_result': vm.bipsst_screen.screen_spring_result,
                'what_problem': vm.bipsst_problem.target_behavior_problem,
                'when_problem': vm.bipsst_problem.when_problem,
                'why_problem': vm.bipsst_problem.why_problem,
                'replacement_behavior': vm.bipsst_problem.replacement_behavior,
                'convey_expectation': vm.bipsst_problem.convey_expectation,
                'demonstrate_des_behave': vm.bipsst_problem.demonstrate_des_behave,
                'additional_comments': vm.bipsst_problem.additional_comments,
                'concerns': vm.bipsst_concernform.concerns,
                'area': JSON.stringify(vm.bipsst_concernform.area),
                'concern_other': JSON.stringify(vm.bipsst_concernform.other),
                'intervtype': vm.bipsst_intervention.type,
                'interventions': vm.bipsst_intervention.interventions,
                'intervention_behaviour':JSON.stringify( vm.bipsst_intervention.behaviour),
                'other_intervention': JSON.stringify( vm.bipsst_intervention.other),
                'behavior_subject': vm.additonalBehaviors.subject,
                'addbehaviors': vm.additonalBehaviors.addbehaviors,
                'behavior_rate': JSON.stringify(vm.additonalBehaviors.rate),
                'strength': vm.bip_strength.strengths,
                'strength_other': JSON.stringify(vm.bip_strength.other),
                'monitorcreateSession': vm.create_session_notification,
                'monitoring': JSON.stringify(vm.bipsst_monitoring),
                'monitoring_log': JSON.stringify(vm.bipsst_monitor_log),
                'monitoring_result': JSON.stringify(vm.bipsst_monitor_result)


            };

            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", winURL);
            form.setAttribute("target", winName);
            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    form.appendChild(input);
                }
            }
            document.body.appendChild(form);
            childWindow = window.open('', winName, windowoption);
            form.target = winName;
            form.submit();
            document.body.removeChild(form);
        }

        function checkWindow() {
    		if (childWindow && childWindow.closed) {
    	        window.clearInterval(timer);    	       
    	        $scope.$apply(function(){    	        	
   	        	vm.preview = false;
   	    	     
   	        	});

    	    }
		}


        function Bipsst_submit(formname, form) {

            var bipform = '';
            var preview_form = '';
            addbipSST(form);
            switch (formname) {
                case 'bipsst_form':
                    bipform = vm.Bipsst_form;
                    preview_form = 'Overview';
                    break;
                case 'bipsst_screen':
                    bipform = vm.bipsst_screen;
                    preview_form = 'Screening --Behavior';
                    break;
                case 'behaveinformation':
                    bipform = vm.behaveinformation;
                    vm.behaveinformation.behavior_information = 1;
                    preview_form = 'Behavior information';
                    break;
                case 'attendanceinformation':
                    bipform = vm.attendanceinformation;
                    vm.attendanceinformation.attendance_information = 1;
                    preview_form = 'Attendance information';
                    break;
                case 'strength':
                    bipform = vm.strength;
                    break;
                case 'bipsst_problem':
                    bipform = vm.bipsst_problem;
                    preview_form = 'Problem analysis';
                    break;
            }
            if (bipform.student_id > 0) {


                var flag = 1;
                if (formname === 'bipsst_form') {
                    if (vm.Bipsst_form.date_plan === "") {
                        toastr.error('Date required.');
                        flag = 0;
                    }
                }


                if (formname === 'bipsst_problem') {
                    if (vm.bipsst_problem.target_behavior_problem === "") {
                        flag = 0;
                        toastr.error('Target behavior problem required');

                    } else if (vm.bipsst_problem.when_problem === "") {
                        flag = 0;
                        toastr.error('How frequently does the problem behavior  required');

                    } else if (vm.bipsst_problem.why_problem === "") {
                        flag = 0;
                        toastr.error('Problem Hypothesis required');

                    }

                }
	

                if (flag === 1) {

                    paperworksService.saveipForm('/api/paperwork/aip/form', bipform).then(function(response) {
                        if (response)
                            vm.Bipsst_form.id = response.id;
                        vm.bipsst_screen.reason = response.reason;
                        vm.behaveinformation.reason = response.reason;
                        vm.attendanceinformation.reason = response.reason;
                        vm.strength.reason = response.reason;
                        vm.bipsst_problem.reason = response.reason;
                        bipform.saved = true;
                        toastr.success('Submitted successfuly.');
                        vm.userActivity.push(preview_form + ' saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));

                        vm.create_session_notification = 1 + parseInt(vm.create_session_notification_2);
                        if (vm.create_session_notification >= 7 && vm.is_intervention === 1) {
                            toastr.error('Please create a session to start monitoring and complete the form.');
                        }

                    });
                }
            }

        }

        function save_intervention(formData, form) {

            if (formData.student_id > 0) {
                paperworksService.saveipIntervention('/api/paperwork/aip/intervention', formData).then(function(response) {
                    if (response) {
                        vm.Bipsst_form.id = response;
                        formData.saved = true;
                        toastr.success(' Behavior-SST interventions saved successfuly.');
                        vm.userActivity.push('Behavior-SST interventions saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));

                        vm.create_session_notification += 1;
                        vm.create_session_notification_2 = vm.create_session_notification;
                        vm.is_intervention = 1;

                        if (vm.create_session_notification_2 >= 7 && vm.is_intervention === 1) {
                            toastr.error('Please create a session to start monitoring and complete the form.');
                        }
                    }
                });
            }
            addbipSST(form);
        }

        function save_concern(formname, form) {
            if (vm.bipsst_concernform.student_id > 0) {
                paperworksService.saveipConcern('/api/paperwork/aip/concern', vm.bipsst_concernform).then(function(response) {
                    if (response) {
                        vm.Bipsst_form.id = response;
                        vm.bipsst_concernform.saved = true;
                        toastr.success('Areas of concerns saved successfuly.');
                        vm.userActivity.push('Areas of concerns saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));

                        vm.create_session_notification += 1;
                        vm.create_session_notification_2 = vm.create_session_notification;
                        if (vm.create_session_notification_2 >= 7 && vm.is_intervention === 1) {
                            toastr.error('Please create a session to start monitoring and complete the form.');
                        }
                    }
                });
            }
            addbipSST(form);
        }

        function save_strength(formname, form) {
            if (vm.bip_strength.student_id > 0) {
                vm.bipsst_concernform.reason = 'Behavior';
                paperworksService.saveipForm('/api/paperwork/aip/strength', vm.bip_strength).then(function(response) {
                    if (response) {
                        vm.Bipsst_form.id = response;
                        vm.bip_strength.saved = true;
                        toastr.success('Student Strength saved successfuly.');
                        vm.userActivity.push('Student strengths saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));

                        vm.create_session_notification += 1;
                        vm.create_session_notification_2 = vm.create_session_notification;
                        if (vm.create_session_notification_2 >= 7 && vm.is_intervention === 1) {
                            toastr.error('Please create a session to start monitoring and complete the form.');
                        }
                    }
                });
            }

            addbipSST(form);
        }


        function save_addtionalBehavior(formname) {
            addbipSST(formname);

            vm.additonalBehaviors.formId = vm.Bipsst_form.id;

            paperworksService.saveipForm('/api/paperwork/save-additoinalbehavior', vm.additonalBehaviors).then(function(response) {
                vm.Bipsst_form.id = response;
                vm.additonalBehaviors.saved = true;
                toastr.success('Additional behavior saved successfuly.');
                vm.userActivity.push('Additional behavior saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));

                vm.create_session_notification += 1;
                vm.create_session_notification_2 = vm.create_session_notification;
                if (vm.create_session_notification_2 >= 7 && vm.is_intervention === 1) {
                    toastr.error('Please create a session to start monitoring and complete the form.');
                }
            });


        }

        vm.scrollTo = function(id) {
            $location.hash(id);
            $anchorScroll();
        };

        function intervention_val(id) {
            var intervention_type = '';
            angular.forEach(vm.interventions, function(intervention) {
                if (intervention.id === parseInt(id)) {
                    intervention_type = intervention.name;
                }
            });

            return intervention_type;
        }

        function toggleSelection(value, chkboxesArr) {
            var idx = chkboxesArr.indexOf(value);
            // is currently selected
            if (idx > -1) {
                chkboxesArr.splice(idx, 1);
            }
            // is newly selected
            else {
                chkboxesArr.push(value);
            }

        }


        function create_session(formname) {
            if (vm.Bipsst_form.id > 0 && (vm.create_session_notification >= 7 && vm.is_intervention === 1)) {

                var formData = {
                    student_id: vm.Bipsst_form.student_id,
                    rti_type: 'BIP-SST',
                    type: 'Behavior'
                };

                paperworksService.saveipMonitoring('/api/paperwork/aip/monitoring', formData).then(function(response) {
                    if (response) {
                        vm.bipsst_monitoring.push(response);
                        toastr.success('Session created successfuly.');
                        vm.userActivity.push('Session created at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));
                    }
                });
            } else {
            	if(!vm.bipsst_concernform.saved && vm.bipsst_intervention.saved){
            		toastr.error('Please fillup and saved areaconcern to create session.');
            	}else if(!vm.bipsst_intervention.saved && vm.bipsst_concernform.saved){
            		toastr.error('Please fillup and saved interventions to create session.');
            	}else{
            		toastr.error('Please fillup and saved areaconcern and interventions to create session.');
            	}
                //toastr.error('You are not able to create session.');
            }


        }

        function update_session(formData, form) {
            addbipSST(form);
            var flag = 1;
            if (formData.teacher_name === "") {
                toastr.error('Teacher name required.');
                flag = 0;
            } else if (formData.duration === "") {
                toastr.error('Duration required.');
                flag = 0;
            }

            if (flag === 1) {
                if (vm.Bipsst_form.id > 0 && parseInt(formData.duration) > 0 && formData.teacher_name !== '') {

                    paperworksService.updateipMonitoring('/api/paperwork/aip/monitoring/update', formData).then(function(response) {
                        if (response) {
                            helperService.showAlert('Session updated successfuly.');
                            formData.saved = true;
                            vm.userActivity.push('Session saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));
                            $state.go("classes.roaster");
                        }
                    });
                }
            }


        }

        function delete_session(formData) {
            SweetAlert.confirm("Are you sure?", {
                    title: "Delete!"
                })
                .then(function(isConfirm) {
                    if (isConfirm) {
                        paperworksService.deleteipMonitoring('/api/paperwork/aip/monitoring/delete', formData).then(function(response) {
                            if (response) {
                                var idx = vm.bipsst_monitoring.indexOf(formData);
                                vm.bipsst_monitoring.splice(idx, 1);
                                helperService.showAlert('Session deleted successfuly.');
                                vm.userActivity.push('Session deleted at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));
                            }
                        });
                    }
                }, function(p) {

                });
        }

        function saveResult(formData, form) {
            addbipSST(form);
            paperworksService.saveipMonitoringResult('/api/paperwork/aip/monitoring-result', {
                monitor_result: formData
            }).then(function(response) {
                helperService.showAlert('Comment submitted successfuly.');
                vm.userActivity.push('Comment saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));
            });

        }

        function saveMonitorStatus(formData, indexs, form) {
            addbipSST(form);
            if (formData.status == 2) {
                SweetAlert.confirm("Are you sure?", {
                    title: "Cancel this session!"
                }).then(function(isConfirm) {
                    if (isConfirm) {
                        paperworksService.updateipMonitoring('/api/paperwork/aip/monitoring/update', formData).then(function(response) {
                            if (response) {
                                vm.bipsst_monitoring[indexs].status = formData.status;
                                vm.hideforstatus = formData.id;
                                create_session(formData.type);
                                vm.userActivity.push('Monitor status saved at ' + $filter('date')(new Date(), 'M/d/yy h:mm:ss a'));
                            }
                        });
                    }
                }, function(p) {

                });
            } else {

                paperworksService.updateipMonitoring('/api/paperwork/aip/monitoring/update', formData).then(function(response) {


                    vm.bipsst_monitoring[indexs].status = formData.status;
                    vm.hideforstatus = formData.id;
                    helperService.showAlert('Status changed successfuly.');
                });

            }
        }


        function initialize() {
            vm.Bipsst_form.id = 0;
            vm.Bipsst_form.date_plan = new Date();
            vm.Bipsst_form.category = 2;
            vm.Bipsst_form.type = 2;
            vm.Bipsst_form.teacher_initiating = $rootScope.user.first_name + ' ' + $rootScope.user.last_name;
            vm.Bipsst_form.teacher_collaborator_1 = '';
            vm.Bipsst_form.teacher_collaborator_2 = '';
            vm.Bipsst_form.teacher_collaborator_3 = '';
            vm.Bipsst_form.saved = false;

            vm.bipsst_screen.saved = false;
            vm.bipsst_screen.screen_by = '';
            vm.bipsst_screen.screen_date = new Date();
            vm.bipsst_screen.screen_fall_result = '';
            vm.bipsst_screen.screen_measurement_tool = 'behavior-emotional-screening-system';
            vm.bipsst_screen.screen_midyr_result = '';
            vm.bipsst_screen.screen_spring_result = '';

            vm.bipsst_problem.target_behavior_problem = '';
            vm.bipsst_problem.when_problem = '';
            vm.bipsst_problem.why_problem = '';
            vm.bipsst_problem.replacement_behavior = '';
            vm.bipsst_problem.convey_expectation = '';
            vm.bipsst_problem.demonstrate_des_behave = '';
            vm.bipsst_problem.additional_comments = '';
            vm.bipsst_problem.saved = false;

            vm.bip_strength.strengths = [];
            vm.bip_strength.other = [];
            vm.bip_strength.saved = false;

            vm.bipsst_concernform.area = vm.area_concern;
            vm.bipsst_concernform.concerns = [];
            vm.bipsst_concernform.other = vm.other_concern;
            vm.bipsst_concernform.saved = false;

            vm.bipsst_intervention.interventions = [];
            vm.bipsst_intervention.saved = false;
            vm.bipsst_intervention.type = 'Behavior';

            vm.bipsst_monitoring = [];
            vm.bipsst_monitor_log = [];
            vm.bipsst_monitor_result = [];
        }


        function Reset() {
            SweetAlert.confirm("Are you sure?", {
                    title: "Reset BIP-SST Form!",
                    cancelButtonText: "cancel",
                    confirmButtonText: "Yes"	
                })
                .then(function(isConfirm) {
                    if (isConfirm) {
                        paperworksService.resetip('/api/paperwork/aip/reset', {
                            student_id: vm.Bipsst_form.student_id,
                            rti_type: 'BIP-SST',
                            type: 'Behavior'
                        }).then(function(response) {
                            vm.initialize();
                            $timeout(function () {
                           	 helperService.showAlert('Your All data has been reset. Please re enter.');
                           }, 2000);
                            $state.reload();
                            
                        });
                    }
                }, function(p) {

                });

        }

        function sendtoAdmin() {
            helperService.paperworkformModal(vm.selectedstudent, vm.Bipsst_form.id, 'send-admin-modal', 'md', 'intervention', 'BIP-SST', 'Behavior').then(function() {
            });


        }
        
        function getRelation(value){
        	var relation = '';
        	
        	switch(value){
        	case 1:
        		relation = 'mother';
       			break;
       		case 2:
       			relation = 'father';
       			break;
       		case 3:
       			relation = 'uncle';
       			break;
       		case 4:
       			relation = 'aunt';
       			break;
       		case 5:
       			relation = 'sister';
       			break;
       		case 6:
       			relation = 'brother';
       			break;
       		case 7:
       			relation = 'grandmother';
       			break;
       		case 8:
       			relation = 'grandfather';
       			break;
       		case 9:
       			relation = 'other';
       			break;
        	}
        	return relation;
        }
    }
})();